import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadUsersurvey'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UX/UI 顧客体験 OOUI ユーザーリサーチ ペルソナ カスタマージャーニーマップ'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/download/customerjournymap/'}
        title="カスタマージャーニーマップ | 資料ダウンロード | Aitria（アイトリア）"
        description="カスタマージャーニーマップは、ユーザーがサービスを利用する際にどのような行動や感情を抱くのかを可視化し、全体を俯瞰することで課題を発見できるフレームワークです。顧客の行動を包括的に捉えることで、一貫した顧客体験を提供しましょう。"
      />
      <Template />
    </>
  )
}

export default Download
